<template>
  <div class="condition-layout">
    <MobileHeader :label="$t('nav.shaft_condition')" />
    <!-- Element type nav panel -->
    <div :class="{'condition-layout__left': true, 'show-for-medium': elementType }">
      <ElementTypesNav
        :items="shaftElementTypes"
        v-if="!loading && shaftElementTypes"
      />
      <Loader v-if="loading" />
    </div>
    <!-- Main and right panel -->
    <div :class="{'condition-layout__view': true, 'show-for-medium': !elementType }">
      <router-view></router-view>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';

import useAjax from '@/functions/use_ajax';
import { convertToUnderscore } from '@/functions/convert_to_underscore';

import MobileHeader from '@/components/generic/mobile_header.vue';
import ElementTypesNav from '@/components/shafts/condition/element_types_nav.vue';
import Loader from '@/components/generic/loader.vue';

const props = defineProps({
  elementType: { type: String, required: false, default: null },
  organisationId: { type: String, required: true },
  shaftId: { type: String, required: true },
});

const ajax = useAjax();
const router = useRouter();

const loading = ref(false);
const shaftElementTypes = ref(null);

onMounted(() => {
  loadShaftElementTypes();
});

/**
 * Get shaft element types
 * (for left panel nav)
 */
async function loadShaftElementTypes() {
  loading.value = true;

  let { ok, data } = await ajax(`/organisations/${props.organisationId}/shafts/${props.shaftId}/condition`);

  if (ok) {
    shaftElementTypes.value = data;

    if (!props.elementType) {
      router.replace({
        name: 'shaftScroll',
        params: {
          elementType: convertToUnderscore(Object.keys(shaftElementTypes.value)[0]),
        },
      });
    }
  }

  loading.value = false;
}
</script>
